import { useEffect } from 'react'

const VISUAL_VIEWPORT_HEIGHT_VAR = '--visual-viewport-height'
const VISUAL_VIEWPORT_OFFSET_TOP_VAR = '--visual-viewport-offset-top'

const updateVisualViewportVars = (): void => {
  const viewport = window.visualViewport
  if (!viewport) return

  document.documentElement.style.setProperty(VISUAL_VIEWPORT_HEIGHT_VAR, `${viewport.height}px`)
  document.documentElement.style.setProperty(VISUAL_VIEWPORT_OFFSET_TOP_VAR, `${viewport.offsetTop}px`)

  // iOS WebViews scroll the layout viewport when focusing inputs; reset so content stays anchored.
  if (window.scrollY !== 0) {
    window.scrollTo(0, 0)
  }
}

const clearVisualViewportVars = (): void => {
  document.documentElement.style.removeProperty(VISUAL_VIEWPORT_HEIGHT_VAR)
  document.documentElement.style.removeProperty(VISUAL_VIEWPORT_OFFSET_TOP_VAR)
}

export const useVisualViewportLayout = ({ enabled }: { enabled: boolean }): void => {
  useEffect(() => {
    if (!enabled) return

    const viewport = window.visualViewport
    if (!viewport) return

    const onViewportChange = (): void => {
      updateVisualViewportVars()
    }

    const previousBodyOverflow = document.body.style.overflow
    const previousHtmlOverflow = document.documentElement.style.overflow

    document.body.style.overflow = 'hidden'
    document.documentElement.style.overflow = 'hidden'

    viewport.addEventListener('resize', onViewportChange)
    viewport.addEventListener('scroll', onViewportChange)
    window.addEventListener('orientationchange', onViewportChange)
    onViewportChange()

    return () => {
      viewport.removeEventListener('resize', onViewportChange)
      viewport.removeEventListener('scroll', onViewportChange)
      window.removeEventListener('orientationchange', onViewportChange)
      clearVisualViewportVars()
      document.body.style.overflow = previousBodyOverflow
      document.documentElement.style.overflow = previousHtmlOverflow
    }
  }, [enabled])
}
